import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
export default class IconItem extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onSelect, type } = this.props;
            onSelect(type);
        };
    }
    render() {
        const { prefixCls, type, active, customFontName } = this.props;
        return (React.createElement("li", { className: classNames({ [`${prefixCls}-item-selected`]: active }) },
            React.createElement("div", { onClick: this.handleClick },
                React.createElement(Icon, { customFontName: customFontName, type: type }),
                React.createElement("p", null, type))));
    }
}
IconItem.displayName = 'IconItem';
IconItem.propTypes = {
    prefixCls: PropTypes.string,
    active: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    customFontName: PropTypes.string,
};
